export default "__VITE_ASSET__4WuX0dw___"